<template>
    <b-col v-if="showEnabledFilter === 'order_identifier'">
        <label for="order_identifier">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.order_identifier) }}</label><br/>
        <input id="order_identifier" name="order_identifier" type="text" class="form-control form-control-sm" v-model.trim="value.order_identifier" :placeholder="$t('omt.gui.orders.search.filters.placeholder.product-identifier')" :class="{isFilled: value.order_identifier !== ''}" :disabled="!isFieldEditable('order_identifier')"/>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'fulfilment_method'">
        <label for="fulfilment_method">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.fulfilment_method) }}</label><br/>
        <select id="fulfilment_method" name="fulfilment_method" v-model="value.fulfilment_method" class="form-control form-control-sm" :class="{isFilled: value.fulfilment_method !== ''}" :disabled="!isFieldEditable('fulfilment_method')">
            <option value=""></option>
            <option v-for="(display_name, identifier) in fulfillmentMethods" :value="identifier">{{display_name}}</option>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'dispatch_type'">
        <label for="dispatch_type">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.dispatch_type) }}</label><br/>
        <select id="dispatch_type" name="dispatch_type" v-model="value.dispatch_type" class="form-control form-control-sm" :class="{isFilled: value.dispatch_type !== ''}" :disabled="!isFieldEditable('dispatch_type')">
            <option value=""></option>
            <option v-for="type in $store.state.dispatchTypes" :value="type.identifier">{{type.display_name}}</option>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'dispatcher_type'">
        <label for="dispatcher_type">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.dispatcher_type) }}</label><br/>
        <select id="dispatcher_type" name="dispatcher_type" v-model="value.dispatcher_type" class="form-control form-control-sm" :class="{isFilled: value.dispatcher_type !== ''}" @change="filterDispatcherTypeChanged" :disabled="!isFieldEditable('dispatcher_type')">
            <option value=""></option>
            <option v-for="(display_name, identifier) in dispatcherTypes" :value="identifier">{{display_name}}</option>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'dispatcher_identifier'">
        <div v-if="value.dispatcher_type !== ''">
            <label for="dispatcher_identifier">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.dispatcher_identifier) }}</label><br/>
            <select id="dispatcher_identifier" name="dispatcher_identifier" v-model="value.dispatcher_identifier" class="form-control form-control-sm" :class="{isFilled: value.dispatcher_identifier !== ''}" :disabled="!isFieldEditable('dispatcher_identifier')">
                <option value=""></option>
                <option v-for="dispatcher in dispatchers" :value="dispatcher.identifier">{{dispatcher.display_name}} ({{dispatcher.identifier}})</option>
            </select>
        </div>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'dispatch_request_status'">
        <label for="dispatch_request_status">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.dispatch_request_status) }}</label><br/>
        <select id="dispatch_request_status" name="dispatch_request_status" v-model="value.dispatch_request_status" class="form-control form-control-sm" :class="{isFilled: value.dispatch_request_status !== ''}" :disabled="!isFieldEditable('dispatch_request_status')">
            <option value=""></option>
            <option v-for="(display_name, status) in dispatchRequestStatuses" :value="status">{{display_name}}</option>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'hold_status'">
        <label for="hold_status">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.hold_status) }}</label><br/>
        <select id="hold_status" name="hold_status" v-model="value.hold_status" class="form-control form-control-sm" :class="{isFilled: value.hold_status !== ''}" :disabled="!isFieldEditable('hold_status')">
            <option value=""></option>
            <option v-for="(status) in holdStatuses" :value="status.identifier">{{status.display_name}}</option>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'sales_formula_identifier'">
        <label for="sales_formula_identifier">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.sales_formula_identifier) }}</label><br/>
        <select id="sales_formula_identifier" name="sales_formula_identifier" v-model="value.sales_formula_identifier" class="form-control form-control-sm" :class="{isFilled: value.sales_formula_identifier !== ''}" :disabled="!isFieldEditable('sales_formula_identifier')">
            <option value=""></option>
            <option v-for="(name, identifier) in $store.state.config['sales-formulas']" :value="identifier">{{name}}</option>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'sales_channel_identifier'">
        <label for="sales_formula_identifier">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.sales_channel_identifier) }}</label><br/>
        <select id="sales_channel_identifier" name="sales_channel_identifier" v-model="value.sales_channel_identifier" class="form-control form-control-sm" :class="{isFilled: value.sales_channel_identifier !== ''}" :disabled="!isFieldEditable('sales_channel_identifier')">
            <option value=""></option>
            <option v-for="(name, identifier) in $store.state.config['sales-channels']" :value="identifier">{{name}}</option>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'responsible_location_identifier'">
        <label for="responsible_location_identifier">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.responsible_location_identifier) }}</label><br/>
        <ModelSelect :options="responsibleStoreOptionsForModelSelect" v-model="value.responsible_location_identifier" ref="responsibleLocationInput" />
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'carrier_method'">
        <label for="carrier_method">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.carrier_method) }}</label><br/>
        <select id="carrier_method" name="carrier_method" v-model="value.carrier_method" class="form-control form-control-sm" :class="{isFilled: value.carrier_method !== ''}" :disabled="!isFieldEditable('carrier_method')">
            <option value=""></option>
            <option v-for="method in $store.getters.carriersMethodOptions" :value="method.id" v-html="method.display_name"/>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'payment_method'">
        <label for="payment_method">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.payment_method) }}</label><br/>
        <select id="payment_method" name="payment_method" v-model="value.payment_method" class="form-control form-control-sm" :class="{isFilled: value.payment_method !== ''}" :disabled="!isFieldEditable('payment_method')">
            <option value=""></option>
            <option v-for="method in $store.getters.paymentMethodOptions" :value="method.id" v-html="method.display_name"/>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'has_comments'">
        <label for="has_comments">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.has_comments) }}</label><br/>
        <select id="has_comments" name="has_comments" v-model="value.has_comments" class="form-control form-control-sm" :class="{isFilled: value.has_comments !== ''}" :disabled="!isFieldEditable('has_comments')">
            <option value=""></option>
            <option value="1">Ja</option>
            <option value="0">Nee</option>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'refunds'">
        <label for="refunds">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.refunds) }}</label><br/>
        <select id="refunds" name="refunds" v-model="value.refunds" class="form-control form-control-sm" :class="{isFilled: value.refunds !== ''}" :disabled="!isFieldEditable('refunds')">
            <option value=""></option>
            <option v-for="(display_name, value) in refundsSearchOptions" :value="value">{{ display_name }}</option>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'validation_status'">
        <label>{{ $t(FILTER_COLUMN_DISPLAY_NAMES.validation_status) }}</label><br/>
        <select v-model="value.validation_status" class="form-control form-control-sm" :class="{isFilled: value.validation_status !== ''}" :disabled="!isFieldEditable('validation_status')">
            <option value=""></option>
            <option v-for="(value, index) in ['released', 'on-hold']" :value="value" :key="index">
                {{ $t(`omt.gui.orders.search.results.validation-status.${value}`) }}
            </option>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'has_order_responsible_location'">
        <label>{{ $t(FILTER_COLUMN_DISPLAY_NAMES.has_order_responsible_location) }}</label><br/>
        <select v-model="value.has_order_responsible_location" class="form-control form-control-sm" :class="{isFilled: value.has_order_responsible_location !== ''}" :disabled="!isFieldEditable('has_order_responsible_location')">
            <option value=""></option>
            <option value="1">Ja</option>
            <option value="0">Nee</option>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'has_assign_error'">
        <label>{{ $t(FILTER_COLUMN_DISPLAY_NAMES.has_assign_error) }}</label><br/>
        <select v-model="value.has_assign_error" class="form-control form-control-sm" :class="{isFilled: value.has_assign_error !== ''}" :disabled="!isFieldEditable('has_assign_error')">
            <option value=""></option>
            <option value="0">{{ $t('omt.gui.orders.search.filters.has-assign-error-options.0') }}</option>
            <option value="1">{{ $t('omt.gui.orders.search.filters.has-assign-error-options.1') }}</option>
            <option value="2">{{ $t('omt.gui.orders.search.filters.has-assign-error-options.2') }}</option>
            <option value="3">{{ $t('omt.gui.orders.search.filters.has-assign-error-options.3') }}</option>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'order_placed_from'">
        <label for="order_placed_from">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.order_placed_from) }}</label><br/>
        <input id="order_placed_from" name="order_placed_from" type="date" class="form-control form-control-sm" v-model="value.order_placed_from" :max="value.order_placed_to" :class="{isFilled: value.order_placed_from !== ''}"
               :min="minOrderPlacedFrom" ref="orderPlacedTo" :disabled="!isFieldEditable('order_placed_from')"
        />
        <small><a href="#" @click.prevent="value.order_placed_from = ''" class="text-lowercase">{{ $t('omt.gui.general.action.empty') }}</a></small>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'order_placed_to'">
        <label for="order_placed_to">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.order_placed_to) }}</label><br/>
        <input id="order_placed_to" name="order_placed_to" type="date" class="form-control form-control-sm" v-model="value.order_placed_to" :min="value.order_placed_from" :class="{isFilled: value.order_placed_to !== ''}"
               :disabled="!isFieldEditable('order_placed_to')"
        />
        <small><a href="#" @click.prevent="value.order_placed_to = ''" class="text-lowercase">{{ $t('omt.gui.general.action.empty') }}</a></small>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'max_age_days'">
        <label for="max_age_days">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.max_age_days) }}</label><br/>
        <input id="max_age_days" type="number" class="form-control form-control-sm" v-model="value.max_age_days" :class="{isFilled: value.max_age_days !== ''}"
               min="0" :disabled="isSearchingForOrderPlacedFrom || isSearchingForOrderNumber || !isFieldEditable('max_age_days')" required
               :placeholder="(isSearchingForOrderPlacedFrom || isSearchingForOrderNumber) ? `nvt` : `Ongelimiteerd`"
        />
        <small>Geteld vanaf '{{ $t(FILTER_COLUMN_DISPLAY_NAMES.order_placed_to) }}'</small>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'promised_delivery_date'">
        <label for="promised_delivery_date">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.promised_delivery_date) }}</label><br/>
        <input id="promised_delivery_date" name="promised_delivery_date" type="date" class="form-control form-control-sm" v-model="value.promised_delivery_date" :class="{isFilled: value.promised_delivery_date !== ''}"
               :disabled="!isFieldEditable('promised_delivery_date')"
        />
        <small><a href="#" @click.prevent="value.promised_delivery_date = ''" class="text-lowercase">{{ $t('omt.gui.general.action.empty') }}</a></small>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'address_type'">
        <label for="address_type">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.address_type) }}</label><br/>
        <select id="address_type" name="address_type" v-model="value.address_type" class="form-control form-control-sm" :disabled="!isFieldEditable('address_type')">
            <option value=""></option>
            <option v-for="type in addressTypes" :value="type.identifier">{{ type.display_name }}</option>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'address_name'">
        <label for="address_name">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.address_name) }}</label><br/>
        <input id="address_name" v-model.trim="value.address_name" :placeholder="$t('omt.gui.orders.search.filters.placeholder.name')" class="form-control form-control-sm" name="address_name" type="text"
               :class="{isFilled: value.address_name !== ''}" :disabled="!isFieldEditable('address_name')"/>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'address_city'">
        <label for="address_city">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.address_city) }}</label><br/>
        <input id="address_city" v-model.trim="value.address_city" :placeholder="$t('omt.gui.orders.search.filters.placeholder.city')" class="form-control form-control-sm" name="address_city" type="text"
               :class="{isFilled: value.address_city !== ''}" :disabled="!isFieldEditable('address_city')"/>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'address_zipcode'">
        <label for="address_city">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.address_zipcode) }}</label><br/>
        <input id="address_city" v-model.trim="value.address_zipcode" :class="{isFilled: value.address_zipcode !== ''}" :placeholder="$t('omt.gui.orders.search.filters.placeholder.zipcode')" class="form-control form-control-sm" name="address_zipcode"
               type="text" :disabled="!isFieldEditable('address_zipcode')"/>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'address_email'">
        <label for="address_email">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.address_email) }}</label><br/>
        <input id="address_email" v-model.trim="value.address_email" :placeholder="$t('omt.gui.orders.search.filters.placeholder.email')" class="form-control form-control-sm" name="address_email" type="email"
               :class="{isFilled: value.address_email !== ''}" :disabled="!isFieldEditable('address_email')"/>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'address_country'">
        <label for="address_country">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.address_country) }}</label><br/>
        <select id="address_country" v-model.trim="value.address_country" :class="{isFilled: value.address_country !== ''}" class="form-control form-control-sm" name="address_country" :disabled="!isFieldEditable('address_country')">
            <option value=""></option>
            <option v-for="(name, identifier) in countries" :value="identifier">{{ name }}</option>
        </select>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'customer_identifier'">
        <label for="customer_identifier">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.customer_identifier) }}</label><br/>
        <input id="customer_identifier" name="customer_identifier" type="text" class="form-control form-control-sm" v-model="value.customer_identifier"
               :class="{isFilled: value.customer_identifier !== ''}" :disabled="!isFieldEditable('customer_identifier')"/>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'dispatch_request_batch'">
        <label for="batch_identifier">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.dispatch_request_batch_identifier) }}</label><br/>
        <input id="batch_identifier" name="dispatch_request_batch" type="text" class="form-control form-control-sm" v-model="value.dispatch_request_batch"
               :class="{isFilled: value.dispatch_request_batch !== ''}" :disabled="!isFieldEditable('dispatch_request_batch_identifier')"/>
    </b-col>
    <b-col v-else-if="showEnabledFilter === 'is_paused'">
        <label for="customer_identifier">{{ $t(FILTER_COLUMN_DISPLAY_NAMES.is_paused) }}</label><br/>
        <select id="is_paused" name="is_paused" v-model="value.is_paused" class="form-control form-control-sm" :class="{isFilled: value.is_paused !== ''}" :disabled="!isFieldEditable('is_paused')">
            <option value=""></option>
            <option value="1">Ja</option>
            <option value="0">Nee</option>
        </select>
    </b-col>
    <b-col v-else-if="!showFilter">&nbsp;</b-col>
</template>

<script>
import orderListColumnTitles from "../../../data/orderListColumnTitles";
import countries from "../../../data/countries";
import refundsSearchOptions from "../../../data/refundsSearchOptions";
import {SEARCHABLE_DISPATCH_REQUEST_STATUSES, OrderSearchBase} from "../OrderSearchBase";
import { ModelSelect } from "vue-search-select";

const FILTER_FEATURE_ENABLED_MAPPING = {
    'hold_status': 'hold-orders',
    'payment_method': 'hold-orders',
    'refunds': 'refunds',
    'validation_status': 'import-errors',
    'has_order_responsible_location': 'fallback-orders',
}

export default {
    extends: OrderSearchBase,

    props: {
        showFilter: {required: true},
        searchFilterSet: {required: true},
        value: {required: true},
    },
    components: {
        ModelSelect,
    },
    computed: {
        FILTER_COLUMN_DISPLAY_NAMES() {
            return orderListColumnTitles
        },
        isFeatureForFilterEnabled() {
            const featureIdentifier = FILTER_FEATURE_ENABLED_MAPPING[this.showFilter] ?? null
            return !featureIdentifier || this.isFeatureEnabled(featureIdentifier)
        },
        showEnabledFilter() {
            return (this.isFeatureForFilterEnabled)
                ? this.showFilter
                : null
        },
        dispatchers() {
            return this.$store.state.locationsForUser
                .filter(d => d.location_type.identifier === this.value.dispatcher_type)
                .sort((a,b) => {
                    if (a.display_name > b.display_name) return 1
                    if (a.display_name < b.display_name) return -1
                    return 0
                })
        },
        responsibleStoreOptions() {
            return this.$store.state.locationsForUser
                .filter(d => d.location_type.identifier === 'store')
                .sort((a,b) => {
                    if (a.display_name > b.display_name) return 1
                    if (a.display_name < b.display_name) return -1
                    return 0
                })
        },
        responsibleStoreOptionsForModelSelect() {
            const TRANSLATION_ALL = this.$t('omt.gui.general.label.all-alt');
            const accumulator = this.canUserManageAllStores ? [{ text: TRANSLATION_ALL, value: '' }] : [];

            return this.responsibleStoreOptions.reduce((acc, option) => {
                acc.push({ text: option.display_name, value: option.identifier });
                return acc;
            }, accumulator);
        },
        holdStatuses() {
            return [
                {identifier: 'Review', display_name: 'Geblokkeerd'},
                {identifier: 'Accepted', display_name: 'Geaccepteerd'},
                {identifier: 'Denied', display_name: 'Definitief geblokkeerd'},
            ]
        },
        countries() {
            return countries
        },
        refundsSearchOptions() {
            return refundsSearchOptions
        },
    }
}
</script>

<style scoped lang="scss">
.commaSeparatedList > span:last-child {
    display: none;
}
.isFilled {
    border-color: #007bff; /* Bootstrap primary blue */
}
input[disabled],
select[disabled] {
    background: transparent;
    border-style: none;

    -moz-appearance: none;
    -webkit-appearance: none;
    &::-ms-expand {
        display: none;
    }
}

div.lead {
    // Only show the no results message when the element is the first (and thus only) child
    span.no-results:not(span.no-results:first-child) {
        display: none;
    }
}

div.sortable-chosen {
    background: #CBE4FF;

}
div.draggable {
    span.fa {
        opacity: 0.5;
    }

    cursor: move;

    label {
        cursor: move
    }

    input {
        cursor: default;
    }
}

.hide-pill {
    visibility: hidden;
}
</style>
